import * as URLConfig from "../domain";

const config = URLConfig.config;

const myAppsUrlConfig = {
  myApps: config.jmw + config.jmw_login + "myapps/",
  appIcon: config.rootUrl + "EWWebImages/WebImages/",
  // Vendor's config
  mySubscription: config.jmw + config.jmw_content + "mysubscription/",
  downloadReports:
    config.jmw +
    config.jmw_content +
    "mysubscription/analytics/report/download",
};

export default myAppsUrlConfig;
